<script>
		import {user, view, change_attribute, send_data, send_images, game} from "../client.svelte.js";
		import {exhibit_URL, mapimg_URL} from "../core.js";
		import SessionsTable from "./SessionsTable.svelte";
		import {sections_of, site_of, sectTyp, sectTag} from "./_Prepare.svelte";
		import Sidebar from "../elements/Sidebar.svelte";

    let section = $derived(view.section)
		let isScene = $derived(section.ZUB === 'Scene')
		let site = $derived(site_of(section))
		let num = $derived(view.adventure.sections.map(sectID => user.sections.get(sectID)).findIndex(sect => sect.ID === section.ID) + 1)
    let exhibits = $derived(
			user.exhibits.values()
			.filter(img => img.advtID === view.adventure?.ID && img.sectID === section.SECT)
			.toArray() )
		let flyout = $state(null)
		let uploadInput = $state(), mapInput = $state()

		/// sites to choose for a scene: sites of the adventure, own sites and public sites
		const grpLabels = {advt: "In diesem Abenteuer", priv: "Eigene Sammlung", publ: "Öffentlicher Katalog"}
		let grpdSites = $derived.by(() => {
				const advtSites = Object.values(view.adventure?.sites ?? {}).map(siteID => user.sites.get(siteID)).filter(Boolean)
				const others = user.sites.values().filter(site => !advtSites.includes(site)).toArray()
				return {
					advt: advtSites,
					priv: others.filter(site => site.owner === user.ID),
					publ: others.filter(site => site.owner !== user.ID && (!site.owner || site.owner === 'PUBLIC')) }
		})

    // $inspect("SECTION - site", section, site)


    async function delete_section() {
        const confirmed = window.confirm("Wollen sie diesen Abschnitt wirklich löschen?")
        if (confirmed) {
            send_data(`/section/${section.ID}`, {}, 'DELETE')
            history.back()
        }
    }

		async function pick_site(pickedSite) {
				console.log(`SECTION: Select site ${pickedSite.ID} as site for section ${section.ID}.`)
				await send_data(`/section/${section.ID}`, {siteID: pickedSite.ID}, 'PATCH')
				flyout = null
		}

    async function upload_map(e) {
				const mapfile = e.target.files[0]
				const siteID = section.siteID ?? section.ID
        if (!mapfile)  return
        console.log(`SECTION: Upload map ${mapfile.name} to site ${siteID} and layer "".`)
        await send_data(`/layer/${siteID}_`, {SITE: siteID, LAYER: ""}, 'POST', mapfile)
				flyout = null
		}

		async function deploy_characters() {
				view.select_section(section.ID)
				await view.select_site(section.siteID ?? section.ID)		// Might fetch site data from server
				view.switch_layout('advt-deploy', {mode: 'deploy'})
		}

		async function edit_site() {
				await view.select_site(site.ID)
				view.switch_layout('advt-siteDetails')
		}

    async function upload_image(e) {
				const imgfiles = Array.from(e.target.files)
        if (imgfiles.length > 0) {
            const params = {type: 'image', SECT: section.SECT}
            send_images(imgfiles, params)
        }
		}

    async function delete_image(e, exhibit) {
				e.stopPropagation()
		    try {
				    await send_data(`/exhibit/${exhibit.ID}`, {image: exhibit.ID}, 'DELETE')
		    } catch (err) {
						console.error(`SECTION: image ${exhibit.ID} could not be deleted`, err)
		    }
	    }

</script>


<!------------------------------- HTML ------------------------------------->

{#snippet sitepick()}
	<button class="button-secondary" onclick={() => mapInput.click()}><i class="fa icon-upload"></i>Karte hochladen</button>
	<input bind:this={mapInput} type=file accept=".jpg, .jpeg, .webp" onchange={upload_map}/>
	{#each Object.entries(grpdSites) as [group, sites]}
		{#if sites.length}
			<h4>{grpLabels[group]}</h4>
			{#each sites as pickable (pickable.ID)}
				<button class="pickRow" class:selected={pickable.ID === site?.ID} onclick={() => pick_site(pickable)}>
					<img src={mapimg_URL(pickable)} alt={pickable.ID}>
					<span>
						<span>{pickable.name}</span>
						<span class="card-meta">{pickable.ID}</span>
					</span>
				</button>
			{/each}
		{/if}
	{/each}
{/snippet}

<section id={view.layout.page} class="prepare-page">
	{#if !game.ID}
		<Sidebar bind:open={flyout} flyout={sitepick} items={[
			{id: 'sitepick', help: 'map', icon: 'map', label: "Karte wählen", flyout: "Karte wählen", shown: isScene},
			{id: 'upload', help: 'exhibits', icon: 'upload', label: "Bilder", title: "Bilder hochladen", onclick: () => uploadInput.click()},
			{id: 'deploy', icon: 'users', label: "Aufstellung", shown: isScene && !!site, onclick: deploy_characters},
			{id: 'delete', icon: 'trash', label: "Löschen", title: "Abschnitt löschen", onclick: delete_section} ]}/>
	{/if}

	<article class="page">
		<header class="pageHead">
			<div class="titleRow">
				<span class="tag {sectTag[section.ZUB]}">{sectTyp[section.ZUB]}</span>
				<span class="card-meta">Abschnitt {num} · {section.ID}</span>
			</div>
			<input id="name" class="titleInput" value={section.name} aria-label="Name des Abschnitts" disabled={!!game.ID}
			       onchange={change_attribute.bind(section)}>
		</header>

		<div class="columns">
			{#if !game.ID}
				<fieldset class="card" data-help="plot">
					<h3 class="card-title">Handlung</h3>
					<div class="field">
						<textarea id="plot" rows="14" value={section.plot ?? ""} onchange={change_attribute.bind(section)}></textarea>
					</div>
				</fieldset>
			{/if}

			<div class="column">
				{#if isScene}
					<fieldset class="card" data-help="map">
						<div class="cardHead">
							<h3 class="card-title">Karte / Ort</h3>
							<span class="card-meta push">{site?.name ?? "keine Karte gewählt"}</span>
						</div>
						<button class="mapBox" title="Karte wählen" disabled={!!game.ID} onclick={() => flyout = 'sitepick'}>
							{#if site}
								<img src={mapimg_URL(site)} alt={site.name}>
							{:else}
								<span class="placeholder"><i class="fa icon-map"></i>Karte wählen</span>
							{/if}
						</button>
						{#if site}
							<div class="button-row">
								<button class="button-secondary" onclick={edit_site}><i class="fa icon-tree"></i>Umgebung</button>
								<button class="button-secondary" onclick={deploy_characters}><i class="fa icon-users"></i>Aufstellung</button>
							</div>
						{/if}
						{#if game.ID}
							<SessionsTable />
							{#if game.section}
								<menu class="button-row" data-help="enter">
									{#if !game.inEncounter}
										<li><button class="btn-primary btn-primary-circle icon-enter" onclick={game.enter_encounter}>Neu betreten</button></li>
									{:else}
										<li><button class="btn-primary btn-primary-circle icon-exit" onclick={game.leave_encounter}>Verlassen</button></li>
									{/if}
								</menu>
							{/if}
						{/if}
					</fieldset>
				{/if}

				<fieldset class="card" data-help="exhibits">
					<h3 class="card-title">Bilder des Abschnitts</h3>
					<div class="imageGrid">
						{#each exhibits as exhibit (exhibit.ID)}
							<div class="exhibit" class:exhibited={game.exhibits.includes(exhibit.ID)}>
								<button class="show" title={exhibit.ID} onclick={() => view.exhibit = exhibit}>
									<img src={exhibit_URL(exhibit)} alt={exhibit.title ?? exhibit.ID}>
								</button>
								<span class="caption">{exhibit.title}</span>
								{#if !game.ID}
									<button class="delete fa icon-trash" title="Bild löschen" aria-label="Bild löschen"
									        tabindex="-1" onclick={(e) => delete_image(e, exhibit)}></button>
								{/if}
							</div>
						{/each}
						{#if !game.ID}
							<label class="uploadTile">
								<i class="fa icon-upload"></i>Bilder hochladen
								<input bind:this={uploadInput} type=file accept=".jpg, .jpeg, .webp" multiple onchange={upload_image} />
							</label>
						{/if}
					</div>
				</fieldset>
			</div>
		</div>
	</article>
</section>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	h3, h4
		margin: 0

	h4
		margin-top: 6px
		font-size: 12px
		font-weight: 500
		color: colors.$grey-60

	textarea
		min-height: 320px
		font-size: 15px
		line-height: 1.55
		field-sizing: content

	.mapBox
		display: grid
		place-items: center
		width: 100%
		aspect-ratio: 16 / 10
		margin: 0
		padding: 0
		border: 0
		border-radius: 8px
		overflow: hidden
		background: radial-gradient(ellipse at 30% 20%, colors.$grey-20, colors.$black 75%)
		cursor: pointer

		img
			max-width: 100%
			height: 100%
			aspect-ratio: auto
			//object-fit: contain

		&:disabled
			cursor: default

	.placeholder
		display: flex
		flex-direction: column
		align-items: center
		gap: 8px
		color: colors.$grey-60
		font-size: 13px

		.fa
			font-size: 30px
			color: colors.$grey-30

	.exhibit
		position: relative
		display: flex
		flex-direction: column
		gap: 6px
		margin: 0

		.show
			margin: 0
			padding: 0
			border: 0
			background: none
			cursor: zoom-in

		img
			display: block
			width: 100%
			aspect-ratio: 1
			object-fit: cover
			border-radius: 8px
			border: 1px solid colors.$grey-30

		&.exhibited img
			border-color: colors.$primary-100

		.caption
			font-size: 12px
			color: colors.$grey-85

		.delete
			position: absolute
			top: 6px
			right: 6px
			margin: 0
			padding: 6px
			border: 0
			border-radius: 6px
			background: rgba(0, 0, 0, 0.65)
			color: colors.$grey-85
			font-size: 12px
			opacity: 0
			cursor: pointer

			&:hover
				color: colors.$white
				background: colors.$highlight-red-060-black

		&:hover .delete, .delete:focus-visible
			opacity: 1

	input[type=file]
		display: none

	/* — map selection in the flyout — */
	.pickRow
		display: flex
		align-items: center
		gap: 10px
		margin: 0
		padding: 6px
		border: 1px solid transparent
		border-radius: 8px
		background: transparent
		color: inherit
		font-size: 13px
		text-align: left
		cursor: pointer

		img
			flex: none
			width: 56px
			height: 40px
			object-fit: cover
			border-radius: 4px
			background: colors.$grey-20

		> span
			display: flex
			flex-direction: column
			gap: 2px

		&:hover
			background: rgba(255, 255, 255, 0.06)

		&.selected
			border-color: colors.$primary-100
			background: colors.$primary-040-black

</style>
